import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-7ZQFWVX7DP";

/**
 * Resets window scroll on route change AND fires a Google Analytics pageview
 * for SPA navigation (gtag's initial config only fires once on first load).
 *
 * If the URL has a hash, jumps to that anchor instead of resetting scroll.
 */
export default function ScrollToTop() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (hash) {
      let tries = 0;
      const max = 12; // 12 × 50ms = 600ms
      const tick = () => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "instant", block: "start" });
          return;
        }
        tries += 1;
        if (tries < max) {
          setTimeout(tick, 50);
        } else {
          window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
      };
      tick();
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }

    // Send a GA4 pageview for the new SPA route.
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + search + hash,
        page_location: window.location.href,
        page_title: document.title,
        send_to: GA_ID,
      });
    }
  }, [pathname, hash, search]);

  return null;
}
